import { jsx as _jsx } from "react/jsx-runtime";
import { TonConnectUIProvider } from '@tonconnect/ui-react';
export const withTonConnect = (component) => () => (_jsx(TonConnectUIProvider, { manifestUrl: "https://gist.github.com/anovic123/237b5669ed8b5aac4b95a146fecd3207.txt", children: component() }));
